import React, { useState, useEffect, useContext, useRef } from 'react'
import Highcharts from 'highcharts'
import i18n from 'live/services/i18n'
import { deepFind } from '../../../utils/utils'
import styled from 'styled-components'

type Series = {
    name: string
    color: string
    value: any
    legendTitle: string
    subtitle?: string
}

type IProps = {
    title?: string
    subtitle?: string
    unity?: string
    series: Series[]
    height: number
    width: number
}

const renderPointForm = point => {
    return `
        <div style="background: none; border: none">
            <span style="font-size: 13px; "> ${point.custom.legendTitle} </span>  <br/>
            <span style="color:${point.color};">\u25CF</span>  
            <span style="font-size: 12px; word-break: keep-all;"> ${point.name}: </span>
            <b style="font-size: 13px; margin-right: 2px">${
                point?.custom?.subtitle ? point?.custom?.subtitle : point.y
            }${' '}</b> 
            <b style="font-size: 13px;">${
                point?.custom?.subtitle ? '' : point.custom.unity ? point.custom.unity : ''
            }</b><br/>   
        </div>
    `
}

const hichartProps: Highcharts.Options = {
    chart: { type: 'pie', spacing: [0, 0, 0, 0] },
    title: {
        text: '',
        floating: true,
        verticalAlign: 'middle'
    },
    tooltip: {
        style: {
            color: '#ffff',
            position: 'inherit',
            transformStyle: 'flat',
            zIndex: 9
        },
        className: 'teste-tooltip',
        backgroundColor: '#ffff',
        borderColor: '#C8CCD4',
        shadow: true,
        formatter: function () {
            return renderPointForm(this.point)
        }
    },
    plotOptions: {
        pie: { innerSize: 10, size: 150, dataLabels: [] }
    },
    series: [
        {
            type: 'pie',
            name: '',
            size: '90%',
            innerSize: '70%'
        }
    ]
}

const Donut = ({ series, title = '', subtitle = '', unity, height = 200, width = 200 }: IProps) => {
    const [chart, setChart] = useState<Highcharts.Chart>()
    const refChart = useRef()
    const wrapperRef = useRef<HTMLDivElement>()
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        if (chart && series.length > 0) {
            const newSerie = series.map(({ value, color, name, legendTitle, subtitle }) => {
                const y = value || 0.5

                return { color, name, y, custom: { unity, legendTitle, subtitle } }
            })

            const htmlContentTitle = `
                    <span style="color: #364159; font-size: 16px; font-weight: 600; "> ${title} </span>
                    <br/>
                    <span style="color: #364159; font-size: 10px; font-weight: 400;  margin-top: 7px;"> ${subtitle} </span>
            `

            chart?.series[0].setData(newSerie)

            chart.setTitle({ text: htmlContentTitle, margin: 0 })

            chart?.reflow()

            setIsLoading(false)
        }
    }, [chart, series])

    useEffect(() => {
        // if (chart) chart.update(chart.options)
        chart?.reflow()
    }, [chart, wrapperRef.current?.offsetHeight, wrapperRef.current?.offsetWidth, height, width])

    useEffect(() => {
        if (!chart && refChart.current) {
            const chart = { ...hichartProps.chart, renderTo: refChart?.current }
            const props: Highcharts.Options = { ...hichartProps, chart }
            const chartAux = Highcharts.chart(props)

            setChart(() => chartAux)
        }
    }, [refChart])

    return (
        <Wrapper ref={wrapperRef}>
            {isLoading && <div className="loading" />}

            <Content style={{ height: height, width: width }}>
                <div className="wrapper-item-chart">
                    <div
                        ref={refChart}
                        style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    />
                </div>

                <div className="wrapper-item-legends">
                    <ul>
                        {series?.map(({ name, value, color, subtitle }, key) => {
                            return (
                                <li key={key}>
                                    <i style={{ color, marginRight: 8 }} className="fas fa-circle"></i>
                                    {i18n(name)}: <b>{subtitle !== '' ? subtitle : value + ' ' + (unity || '')}</b>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </Content>
        </Wrapper>
    )
}

export default Donut

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: flex-start;

    .wrapper-item-chart {
        flex-grow: 1;
        min-height: 40%;
        max-height: 85%;
        width: 100%;
        padding: 0;
    }

    .wrapper-item-legends {
        height: auto;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    ul {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        li {
            margin: 8px 0;
            font-family: ${({ theme }) => theme['font-regular']};
            font-weight: 400;
            b {
                font-family: ${({ theme }) => theme['font-regular']};
                font-weight: 600;
            }
        }
    }

    .temperatura-umidade-empty-container {
        position: absolute;
        margin: 0 auto;
        z-index: 1;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
            background: #f5f5f5;
            width: 218px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #c8ccd4;
            padding: 8px 13px;
            text-align: center;

            i {
                font-size: 40px;
                color: #868695;
            }

            span {
                font-size: 13px;
            }
        }
    }
`
